import React, {ButtonHTMLAttributes} from 'react';
import {Button} from "@/components/ui/button";
import {LargeButtonProps} from "@/components/interfaces/global-interfaces";
import Link from "next/link";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/components/ui/tooltip";
import {AlertOctagonIcon, HeartIcon} from "lucide-react";
import {SingleProductEnum} from "@/constants/commerce-enum";

function LargeButton({title, error, variant, customClass, href, ...props}: LargeButtonProps) {

    return (
        <> {href ?
            (

                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Link href={href}>
                                <Button   {...props} onClick={props.onClick} variant={variant}
                                          className={`${customClass} w-full text-sm md:text-base  h-[48px] border rounded-xl  active:scale-95 transition ${variant === "disable" && "cursor-auto"}`}>
                                    {title}
                                </Button>
                            </Link>

                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{
                                error && error
                            }</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>

            ) : (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <div className={"w-full flex flex-wrap"}>
                                {error ? (
                                    <div className={"w-full flex text-xs mb-4 text-red-400 items-center gap-1"}>
                                        <AlertOctagonIcon className={"h-4"}/>
                                        {
                                            error && error
                                        }
                                    </div>
                                ) : null}
                                <Button  {...props} onClick={props.onClick} variant={variant}
                                         className={`${customClass} w-full text-sm md:text-base  h-[48px]  rounded-xl  active:scale-95 transition ${variant === "disable" && "cursor-auto"} `}>
                                    {title}
                                </Button>
                            </div>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{
                                error && error
                            }</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>

            )
        }

        </>
    );
}

export default LargeButton;

